// Executed Entirely Client Side

if (!window.module) { window.module = { exports: {} }; }

String.Format = function(str) {
  var args = [].slice.call(arguments);
  args.shift();

  for (var i = 0, len = args.length; i < len; i++) {
    str = str.replace(new RegExp('\\{' + i + '}', 'g'), args[i]);
  }

  return str;
};

String.IsNullOrEmpty = function(str) {
  return !str || str === '';
};

String.IsNullOrWhiteSpace = function(str) {
  if (!str) { return true; }
  return str.replace(/\s/g, '').length < 1;
};

String.Join = function(delimiter, arr) {
  return arr.join(delimiter);
};
